import { createAction, createAsyncAction } from 'typesafe-actions';
import { JsonContestItem } from './types';

export const fetchContestItem = createAsyncAction(
  'contest/FETCH_REQUEST',
  'contest/FETCH_SUCCESS',
  'contest/FETCH_FAILURE'
)<void, JsonContestItem, Error>();

export const updateContest = createAction('contest/GET_CONTEST_ITEM', resolve =>
  (contestId: string) => resolve(contestId)
);

export const removeContestDetail = createAction('contest/REMOVE_CONTEST_DETAIL', resolve =>
  () => resolve()
);
